import { Routes } from '@angular/router';
import { AI_AGENTS_ROUTES } from '@features/ai-agents/ai-agents.routes';
import { AUTO_ASSIGNMENTS_ROUTES } from '@features/auto-assignments/auto-assignments.routes';
import { AUTOMATIC_REPLIES_ROUTES } from '@features/settings/automatic-replies/automatic-replies.routes';
import { AUTOMATION_SLUGS, FLOWS_SLUGS, MAIN_SLUGS } from '../../routes/routes.types';

export const FLOWS_ROUTES: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: FLOWS_SLUGS.table,
    },
    {
        path: FLOWS_SLUGS.table,
        title: 'Flows',
        loadComponent: () =>
            import('@features/automation/flows/flow-table/flow-table.component').then(
                m => m.FlowTableComponent
            ),
    },
    {
        path: FLOWS_SLUGS.editor,
        title: 'Flow Editor',
        loadComponent: () =>
            import('@features/automation/flows/flow-editor/flow-editor.component').then(
                m => m.FlowEditorComponent
            ),
    },
    {
        path: FLOWS_SLUGS.init,
        title: 'Flow Init',
        loadComponent: () =>
            import('@features/automation/flows/flow-initialize/flow-initialize.component').then(
                m => m.FlowInitializeComponent
            ),
    },
    {
        path: FLOWS_SLUGS.landing,
        title: 'Flow Landing',
        loadComponent: () =>
            import('@features/automation/flows/flow-landing/flow-landing.component').then(
                m => m.FlowLandingComponent
            ),
    },
    {
        path: FLOWS_SLUGS.templates,
        title: 'Flow Templates',
        loadComponent: () =>
            import('@features/automation/flows/flow-templates/flow-templates.component').then(
                m => m.FlowTemplatesComponent
            ),
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: FLOWS_SLUGS.table,
    },
];

export const AUTOMATION_ROUTES: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: AUTOMATION_SLUGS.overview,
    },
    {
        path: AUTOMATION_SLUGS.overview,
        title: 'Automation Overview',
        loadComponent: () =>
            import('@features/automation/automation-overview/automation-overview.component').then(
                m => m.AutomationOverviewComponent
            ),
    },
    {
        path: AUTOMATION_SLUGS.flows,
        children: FLOWS_ROUTES,
    },
    {
        path: AUTOMATION_SLUGS.context,
        title: 'Context',
        loadComponent: () =>
            import('@features/automation/context/context-documents.component').then(
                m => m.ContextDocumentsComponent
            ),
    },
    {
        // '/editor' suffix keeps it matched by the layout's fullscreen-route pattern
        path: `${AUTOMATION_SLUGS.orchestrations}/editor`,
        title: 'Agent Orchestration',
        loadComponent: () =>
            import('@features/automation/orchestration/orchestration-builder.component').then(
                m => m.OrchestrationBuilderComponent
            ),
    },
    {
        path: MAIN_SLUGS.aiAgents,
        children: AI_AGENTS_ROUTES,
    },
    {
        path: 'assignment', // TODO: Use a slug constant. I'll use string for now or add to routes.types.ts
        children: AUTO_ASSIGNMENTS_ROUTES,
    },
    {
        path: AUTOMATION_SLUGS.automaticReplies,
        children: AUTOMATIC_REPLIES_ROUTES,
    },
];
